
































import Vue from "vue";
import { EXERCISE_TYPE } from "@tt-app/constants";

import DrillReviewSummary from "@tt-app/components/exercise/DrillReviewSummary.vue";
import IconDrillListening from "@joyz/app-core/assets/icons/default/DrillListening.svg";
import IconDrillPronunciation from "@joyz/app-core/assets/icons/default/DrillPronunciation.svg";
import IconDrillTyping from "@joyz/app-core/assets/icons/default/DrillTyping.svg";
import IconDrillVocabulary from "@joyz/app-core/assets/icons/default/DrillVocabulary.svg";
import IconLeft from "@joyz/app-core/assets/icons/black/ChevronLeft.svg";
import IconRight from "@joyz/app-core/assets/icons/black/ChevronRight.svg";
import { DrillState, ExerciseType } from "@tt-app/models";
import TranslationQuestion from "@tt-app/components/exercise/drill/TranslationQuestion.vue";
import DrillTips from "@tt-app/components/exercise/drill/DrillTips.vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

interface Data {
  currentIndex: number;
}

interface Methods {
  goToPage: (pageIndex: number) => void;
}

interface Computed {
  icons: { [key: string]: string };
  questionsCount: number;
  reviewData: any;
  showingSummary: boolean;
  summaryIndex: number;
}

interface Props {
  allCorrect: boolean;
  answers: any;
  audioDecoderPlayer: AudioDecoderPlayer;
  drill: DrillState;
  exerciseType: ExerciseType;
  questionsByUuid: any;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReviewComposition",

  components: {
    DrillTips,
    DrillReviewSummary,
    TranslationQuestion
  },

  props: {
    allCorrect: { type: Boolean, default: false },
    answers: { type: Object, default: () => ({}) },
    audioDecoderPlayer: { type: AudioDecoderPlayer, default: undefined },
    drill: { type: Object as () => DrillState, required: true },
    exerciseType: { type: Number as () => ExerciseType, required: true },
    questionsByUuid: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      currentIndex: this.drill.exercises.length
    };
  },

  methods: {
    goToPage(pageIndex) {
      if (pageIndex > this.summaryIndex) {
        this.currentIndex = 0;
        return;
      }

      if (pageIndex < 0) {
        this.currentIndex = this.summaryIndex;
        return;
      }

      this.currentIndex = pageIndex;
    }
  },

  computed: {
    icons() {
      let cardIcon = "";
      switch (this.exerciseType) {
        case EXERCISE_TYPE.DRILL_LISTENING:
          cardIcon = IconDrillListening;
          break;
        case EXERCISE_TYPE.DRILL_PRONUNCIATION:
          cardIcon = IconDrillPronunciation;
          break;
        case EXERCISE_TYPE.DRILL_VOCABULARY:
          cardIcon = IconDrillVocabulary;
          break;
        case EXERCISE_TYPE.DRILL_TRANSLATION:
          cardIcon = IconDrillTyping;
          break;
        default:
          throw new Error(`Unsupported drill exercise type: ${this.exerciseType}`);
      }

      return {
        card: cardIcon,
        left: IconLeft,
        right: IconRight
      };
    },

    questionsCount() {
      return this.drill.exercises.length;
    },

    reviewData() {
      return Object.entries(this.answers)[this.currentIndex];
    },

    showingSummary() {
      return this.currentIndex === this.summaryIndex && !this.allCorrect;
    },

    summaryIndex() {
      return this.questionsCount;
    }
  }
});
